<template>
  <div class="container matter-info-container">
    <div class="container">
      <div>
        <h5 class="text-start fw-bold mb-4">
          Enter the Matter name from Salesforce, e.g., MAT-12345678910:
        </h5>
        <form class="container d-flex justify-content-start">
          <div
            class="text-start row col-4 col-lg-3 col-xl-2 col-xxl-2 col-md-4 col-sm-4 col-"
          >
            <input
              v-model="matterName"
              type="text"
              class="form-control fw-medium border-black"
              placeholder="MAT-12345678910"
            />
          </div>

          <div
            class="row col-4 col-lg-2 col-xl-2 col-xxl-2 col-md-3 col-sm-4 ms-5"
          >
            <button
              v-if="!loading"
              :disabled="!matterName"
              class="btn btn-primary fw-bold"
              @click="submit"
            >
              Submit
            </button>
            <button
              v-else
              class="btn btn-primary fw-bold"
              type="button"
              disabled
            >
              <span
                class="spinner-border spinner-border-sm me-3"
                aria-hidden="true"
              />
              <span role="status">Loading...</span>
            </button>
          </div>
        </form>
      </div>

      <div v-if="error" class="text-start fw-bold mb-4 mt-2 text-danger">
        {{ error }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { submitMatterName } from '@/common/api';
import { defineComponent } from 'vue';
import { handleError } from '@/common/errors';

export default defineComponent({
  name: 'MatterSubmit',

  emits: ['submit'],

  data() {
    return {
      loading: false,
      matterName: '',
      error: '' as string | Error,
    };
  },

  methods: {
    async submitMatterName() {
      this.loading = true;

      try {
        const response = await submitMatterName(this.matterName);

        if (response.status === 200) {
          if (!response.data.matterInfo.matterName) {
            this.error =
              "There's no such Matter name. Please make sure you enter an existing Matter name and try again.";
            return;
          }
          return response.data;
        }
      } catch (error: unknown) {
        this.error = error as Error;
        handleError(error, 'Failed to fetch matter info');
      } finally {
        this.loading = false;
      }
    },

    async submit(event: Event) {
      event.preventDefault();

      this.error = '';

      if (!this.isFormValid()) {
        this.error =
          'Invalid Matter name. Please enter a valid Matter name in the format MAT-12345678910.';
        return;
      }

      const matterSubmitResponse = await this.submitMatterName();

      if (matterSubmitResponse) {
        this.matterName = matterSubmitResponse.matterInfo.matterName;
        this.$emit('submit', matterSubmitResponse);
      }
    },

    isFormValid() {
      const pattern = /^MAT-\d{11}$/;
      return pattern.test(this.matterName.trim());
    },
  },
});
</script>
